import App from '@/App';
import { ProtectedApp } from '@/components/ProtectedApp';
import { UploadQueueProvider } from '@/context/UploadQueueContext';
import { onSigninCallback, userManager } from '@/config/keycloak';
import '@/i18n/config';
import { Layout } from '@/layout/Layout';
import { PrimeReactProvider } from 'primereact/api';
import Tailwind from 'primereact/passthrough/tailwind';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import '@/styles/index.css';
import 'react-toastify/dist/ReactToastify.css';

import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename="/">
      <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
        <PrimeReactProvider value={{ pt: Tailwind }}>
          <Layout>
            <ProtectedApp>
              <UploadQueueProvider>
                <App />
              </UploadQueueProvider>
            </ProtectedApp>
            <ToastContainer position="bottom-right" autoClose={6000} newestOnTop={true} draggable={false} />
          </Layout>
        </PrimeReactProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
